<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Podaj dane teleadresowe</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="tel"
							data-vv-name="phoneNumber"
							data-vv-as="Telefon"
							:error-messages="vErrors.collect('scope2.phoneNumber')"
							label="Telefon *"
							aria-label="label for phone number"
							for="step-address-data-component-phone"
							id="step-address-data-component-phone"
							v-model="stepData.phoneNumber"
							v-validate="{required: true, regex: /^[0-9 +-]*$/}"
							data-vv-validate-on="none"
							data-vv-scope="scope2">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs4>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="correspondenceStreet"
							data-vv-as="Ulica"
							:error-messages="vErrors.collect('scope2.correspondenceStreet')"
							label="Ulica *"
							aria-label="label for correspondence address street"
							for="step-address-data-component-street"
							id="step-address-data-component-street"
							v-model="stepData.address.street"
							v-validate="'required'"
							data-vv-scope="scope2">
						</v-text-field>
					</v-flex>
					<v-flex xs1>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="correspondenceBuilding"
							data-vv-as="Budynek"
							:error-messages="vErrors.collect('scope2.correspondenceBuilding')"
							label="Budynek *"
							aria-label="label for corresponding address building number"
							for="step-address-data-component-building"
							id="step-address-data-component-buiding"
							v-model="stepData.address.building"
							v-validate="'required'"
							data-vv-scope="scope2">
						</v-text-field>
					</v-flex>
					<v-flex xs1>
						<v-text-field
							browser-autocomplete="off"
							label="Lokal"
							aria-label="label for corresponding address apartment number"
							for="step-address-data-component-apartment"
							id="step-address-data-component-apartment"
							v-model="stepData.address.apartment">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs2>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="correspondencePostalCode"
							data-vv-as="Kod pocztowy"
							:error-messages="vErrors.collect('scope2.correspondencePostalCode')"
							label="Kod pocztowy *"
							aria-label="label for corresponding address apartment number"
							for="step-address-data-component-postal-code"
							id="step-address-data-component-postal-code"
							v-model="stepData.address.postalCode"
							v-validate="{ required: true, regex: /^([0-9]{2}-[0-9]{3})$/}"
							return-masked-value
							:mask="'##-###'"
							data-vv-validate-on="none"
							data-vv-scope="scope2">
						</v-text-field>
					</v-flex>
					<v-flex xs4>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="correspondenceCity"
							data-vv-as="Miejscowość"
							:error-messages="vErrors.collect('scope2.correspondenceCity')"
							label="Miejscowość *"
							aria-label="label for corresponding address city"
							for="step-address-data-component-city"
							id="step-address-data-component-city"
							v-model="stepData.address.city"
							v-validate="'required'"
							data-vv-scope="scope2">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

				</v-layout>
			</v-container>

		</v-card>
		<v-btn color="blue"
			@click="$emit('step', 1)"
		>Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 3, 'scope2')">
			Dalej
		</v-btn>
	</div>
</template>

<script>
	export default {
		name: "StepAddressDataComponent",
		inject: ["parentValidator"],

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {};
		},

		props: {
			stepData: Object,
		},
	};
</script>

<style scoped>

</style>
